import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSsnCard16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><rect x={10.074} y={7.065} width={1.35} height={1.169} fill={iconColor} /><path d="M4.66667 6.66668H7.33333M4.66667 9.00001H6M10 6.66668H11.3333V8.66668H10V6.66668ZM2.66667 12.6667H13.3333C13.7015 12.6667 14 12.3682 14 12V4.00001C14 3.63182 13.7015 3.33334 13.3333 3.33334H2.66667C2.29848 3.33334 2 3.63182 2 4.00001V12C2 12.3682 2.29848 12.6667 2.66667 12.6667Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoSsnCard16;